export default __webpack_public_path__ + "static/case-studies-11e97a77ac384017d8fda3b0b58db1c5.jpg";